import { SkullScanOutlineIcon } from './SkullScanOutlineIcon';

/**
 * author: Michael Irigoyen
 * id FFA72D4C-C2EE-4492-B556-95C873FF1677
 * name skull-scan-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skull-scan-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const XRayOutlineIcon = SkullScanOutlineIcon;
export default XRayOutlineIcon